(() => {
  const ns = 'http://www.w3.org/2000/svg';
  const transparent = c => c === 'rgba(0, 0, 0, 0)' || c === 'transparent';
  const background = el => {
    for (let p = el.parentElement; p; p = p.parentElement) {
      const c = getComputedStyle(p).backgroundColor;
      if (!transparent(c)) return c;
    }
    return '#fcfaf6';
  };
  const apply = () => {
    const candidates = document.querySelectorAll('main section, main div[class]');
    candidates.forEach(el => {
      if (el.classList.contains('rd-site-wave-band') || el.closest('nav, form, button, dialog, footer, .rd-footer, .rd-newsletter, .rd-ingredient-band, .rd-oil-community, .rd-oil-moment')) return;
      const style = getComputedStyle(el), rect = el.getBoundingClientRect();
      const rgb = style.backgroundColor.match(/[\d.]+/g)?.map(Number);
      if (!rgb || rgb.length > 3 && rgb[3] < .95 || rgb[0] < 145 || rgb[0] > 175 || rgb[1] < 25 || rgb[1] > 55 || rgb[2] < 60 || rgb[2] > 100) return;
      if (rect.width < document.documentElement.clientWidth * .74 || rect.height < 100) return;
      if (el.querySelector(':scope > svg[class*="wave"]') || el.closest('.rd-site-wave-band')) return;
      el.classList.add('rd-site-wave-band');
      el.style.setProperty('--rd-wave-surround', background(el));
      el.style.setProperty('--rd-wave-padding-top', style.paddingTop);
      el.style.setProperty('--rd-wave-padding-bottom', style.paddingBottom);
      ['top', 'bottom'].forEach(edge => {
        const svg = document.createElementNS(ns, 'svg');
        svg.setAttribute('viewBox', '0 0 1440 70');
        svg.setAttribute('preserveAspectRatio', 'none');
        svg.setAttribute('aria-hidden', 'true');
        svg.setAttribute('focusable', 'false');
        svg.classList.add('rd-site-wave', 'rd-site-wave-' + edge);
        const path = document.createElementNS(ns, 'path');
        path.setAttribute('d', edge === 'top' ? 'M0 0H1440V22C1285 65 1160 60 1000 28S730 18 570 43 290 64 140 32 40 18 0 28Z' : 'M0 36C180 3 300 8 450 36S710 64 870 34 1130 1 1280 28 1380 47 1440 30V70H0Z');
        svg.append(path);el.append(svg);
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply); else apply();
  document.addEventListener('shopify:section:load', apply);
})();
